import { platformPricing } from '~/utilities/pricing';


const subscriptions = [
    {
        id: "64624a54006c56df40edb821",
        tag: {
            uk: "Економний тариф",
            en: "Best offer"
        },
        originalPrice: platformPricing.subscriptionReadOnly || 250,
        // text: {
        //     uk: "Для тих, кому не потрібні сертифікати та перевірка робіт",
        //     en: "If you do not need certificates or assignment checking"
        // },
        action: {
            label: "subscribe",
            action: "subscribe",
            classes: ['btn-primary']
        },
        options: [
            {
                label: 'access',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'discounts',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'test',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'submit',
                icon: 'icon-ic-dismiss color-red'
            },
            {
                label: 'review',
                icon: 'icon-ic-dismiss color-red'
            },
            {
                label: 'practice',
                icon: 'icon-ic-dismiss color-red'
            },
            {
                label: 'theory',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'support',
                icon: 'icon-ic-favourite-outline color-green'
            }
        ]
    },
    {
        id: "6101170ec90aff6d4fe9577b",
        tag: {
            uk: "Популярний тариф",
            en: "Good start"
        },
        originalPrice: platformPricing.subscriptionFullAccess || 550,
        rainbow: true,
        // text: {
        //     uk: "Для тих, хто хоче навчатись ґрунтовно",
        //     en: "For those who want to learn thoroughly"
        // },
        action: {
            label: "subscribe",
            action: "subscribe",
            classes: ['btn-primary']
        },
        options: [
            {
                label: 'access',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'discounts',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'test',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'submit',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'review',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'practice',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'theory',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'support',
                icon: 'icon-ic-favourite-outline color-green'
            }
        ]
    },
];
const certificates = [
    {
        slug: "certificate-3-month",
        tag: {
            uk: "Економія 150 грн",
            en: "Save 150 UAH"
        },
        originalPrice: platformPricing.certificate3Months || 1650,
        action: {
            label: "buy",
            action: "buy",
            classes: ['btn-primary']
        },
        thumbnail: {
            name: "access-cert-3m.png",
        },
        options: [
            {
                label: 'access',
                icon: 'icon-ic-tick-thin color-green',
            },
            {
                label: 'discounts',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'test',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'review',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'submit',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'practice',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'theory',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'support',
                icon: 'icon-ic-favourite-outline color-green'
            }
        ]
    },
    {
        slug: "certificate-6-month",
        tag: {
            uk: "Економія 300 грн",
            en: "Save 300 UAH"
        },
        originalPrice: platformPricing.certificate6Months || 3300,
        action: {
            label: "buy",
            action: "buy",
            classes: ['btn-primary']
        },
        thumbnail: {
            name: "access-cert-6m.png",
        },
        options: [
            {
                label: 'access',
                icon: 'icon-ic-tick-thin color-green',
            },
            {
                label: 'discounts',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'test',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'review',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'submit',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'practice',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'theory',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'support',
                icon: 'icon-ic-favourite-outline color-green'
            }
        ]
    },
    {
        slug: "certificate-12-month",
        tag: {
            uk: "Економія 600 грн",
            en: "Save 600 UAH"
        },
        originalPrice: platformPricing.certificate12Months || 6600,
        action: {
            label: "buy",
            action: "buy",
            classes: ['btn-primary']
        },
        thumbnail: {
            name: "access-cert-12m.png",
        },
        options: [
            {
                label: 'access',
                icon: 'icon-ic-tick-thin color-green',
            },
            {
                label: 'discounts',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'test',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'review',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'submit',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'practice',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'theory',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'support',
                icon: 'icon-ic-favourite-outline color-green'
            }
        ]
    },
];
const teamAccess = [
    {
        id: "000",
        tag: {}, // Prevent error
        title: {
            uk: "Навчання: доступ для команд",
            en: "Learning: Team Access"
        },
        text: {
            uk: "Для команд від трьох і більше людей",
            en: "For teams of three or more people"
        },
        price: 1500,
        thumbnail: {
            name: "access-team.jpg"
        },
        subscription: {
            price: 1500
        },
        action: {
            label: "learnMore",
            action: "panel",
            classes: ['btn-bg elevate']
        },
        options: [
            {
                label: 'access',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'discounts',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'test',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'submit',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'review',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'practice',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'theory',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'invoice',
                icon: 'icon-ic-tick-thin color-green'
            },
            {
                label: 'support',
                icon: 'icon-ic-favourite-outline color-green'
            }
        ]
    }
];

export default {
    computed: {
        defaultAccessPlans () {
            return [
                ...subscriptions,
                ...certificates,
            ];
        },

        computedPlans () {
            return this.plans || this.loadedAccessPlans;
        },

        computedCourses () {
            return this.courses || this.loadedAccessCourses;
        },
    },

    methods: {
        async loadAccessPlans () {
            if (this.plans && Array.isArray(this.plans) && this.plans.length > 0) return;
            if (this.accessPlansLoading) return;
            this.accessPlansLoading = true;

            let error;

            let data = await this.$axios.$get(`${this.$axios.defaults.baseURL}/access/getTariffs`, {
                params: {
                    locale: this.locale || 'uk',
                },
            })
            .catch(err => {
                error = err;
            });

            if (error) {
                console.log(error);
                return;
            }

            if (!data) {
                console.log('Data returned empty');
                return;
            }

            this.loadedAccessCourses = data.courses;

            let plans = this.mergeAccessPlans(data, this.defaultAccessPlans);

            this.loadedAccessPlans = plans;
            this.accessPlansLoading = false;
        },

        mergeAccessPlans (data, defaultPlans) {
            let plans = [];

            defaultPlans.forEach(plan => {
                let sub  = data.tariffs.find(o => o.id == plan.id);
                let cert = data.certs.find(o => o.slug == plan.slug);

                if (sub) {
                    plan.thumbnail    = sub.thumbnail;
                    plan.title        = sub.title;
                    plan.price        = sub.price;
                    plan.subscription = sub.subscription;
                }

                if (cert) {
                    plan.id        = cert.id;
                    // plan.thumbnail = cert.thumbnail;
                    plan.title     = cert.title;
                    plan.price     = cert.price;
                    plan.access    = cert;
                }

                plan.brTitle = JSON.parse(JSON.stringify(plan.title || {}));

                for (let key in plan.brTitle) {
                    plan.brTitle[key] = plan.brTitle[key].split(': ').join(':<br>');

                    if (cert) {
                        let words = plan.brTitle[key].split(' ');
                        let firstWord = words.shift();
                        plan.brTitle[key] = [
                            firstWord,
                            words.join(' ')
                        ].join('<br>');
                    }
                }

                if (sub || cert) plans.push(plan);
            });

            return plans;
        },
    },
};
